import {useTranslation} from 'react-i18next';

import {Box, Stack, Typography} from '@mui/material';

import {ApplicantDocuments} from './ApplicantDocuments';
import {Editable} from './Editable';
import ProfilePhoto from './ProfilePhoto';
import Settings from './Settings';
import * as Types from '../../types';

interface Props {
  isMobile?: boolean;
  basicInfo: Types.ProfileBasic;
  settings: Types.ProfileSettings;
  onEdit?: (formType: Types.ProfileFormType) => void;
  onImageChange?: (file: File | null) => void;
  refetchProfile: () => void;
}

export const Header = ({isMobile, basicInfo, settings, onEdit, onImageChange, refetchProfile}: Props) => {
  const {t: td} = useTranslation('domain');
  const genderPronoun = basicInfo.genderPronoun ? td(`genderPronounEnum.${basicInfo.genderPronoun}`) : '';

  return (
    <Editable
      testid='edit-basic-info'
      sx={{
        mt: 5,
      }}
      onEdit={() => onEdit?.('header')}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: isMobile ? 'flex-start' : 'center',
        }}
      >
        <ProfilePhoto onImageChange={onImageChange} imageSrc={basicInfo.profilePictureUrl} isMobile={isMobile} />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            marginLeft: isMobile ? '0px' : '32px',
            marginTop: isMobile ? '8px' : '0px',
          }}
        >
          <Stack direction='row' spacing={2}>
            <Typography variant='h3'>
              {basicInfo.firstName} {basicInfo.lastName}
            </Typography>
            <Typography
              variant='body1'
              color='primary.var70'
              sx={{
                display: !genderPronoun ? 'none' : 'block',
              }}
            >
              ({genderPronoun})
            </Typography>
          </Stack>
          <Typography variant='body1'>{basicInfo.currentJobTitle}</Typography>
          <Typography variant='body1'>{basicInfo.location}</Typography>
          <Typography variant='body1'>{basicInfo.mobilePhoneNumber}</Typography>

          {isMobile && <ApplicantDocuments refetchProfile={refetchProfile} documents={basicInfo.documents} />}
        </Box>
      </Box>
      <Settings
        data={settings}
        sx={{
          display: isMobile ? 'block' : 'none',
        }}
        onEdit={onEdit}
        testid='edit-settings-mobile'
      />
      {!isMobile && <ApplicantDocuments refetchProfile={refetchProfile} documents={basicInfo.documents} />}
    </Editable>
  );
};
